module.exports = __webpack_public_path__ + "static/media/verihubs.b49854ef.png";